import { render } from "./LiveDate.vue?vue&type=template&id=9b974796"
import script from "./LiveDate.vue?vue&type=script&lang=js"
export * from "./LiveDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__